export function outerHeight(el) {
  if (el) {
    const elStyle = getComputedStyle(el)
    return el.offsetHeight + parseInt(elStyle.marginTop) + parseInt(elStyle.marginBottom)
  }
  return 0
}
